import FadeIn from "./FadeIn";

// export default {
//   fadeIn: FadeIn,
// };
const install = function(Vue) {
  Vue.directive('fadeIn', FadeIn);
};
if (window.Vue) {
  Vue.use(install); // eslint-disable-line
}

export default install